/* eslint-disable eqeqeq */
import {
  AbsoluteCenter,
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Text,
  chakra,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginUserAction } from "../../../modules/auth/Actions";
const LoginForm = ({ withTitle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [inputType, setInputType] = useState("password");
  const validateUserName = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  return (
    <div style={{ width: "100%" }}>
      <Formik
        initialValues={{
          phone: "",
          password: "",
        }}
        style={{ width: "100%" }}
        onSubmit={(values) => {
          dispatch(loginUserAction(values));
        }}
      >
        {({ values, errors, touched }) => (
          <Form style={{ width: "100%" }}>
            <Flex
              flexDirection="column"
              w="100%"
              gap={8}
              fontFamily="sans-serif"
            >
              {withTitle && (
                <Heading textAlign={"center"} mb="10px">
                  Login
                </Heading>
              )}
              <Box w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="phone"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    Phone
                  </FormLabel>
                </Flex>

                <Field
                  style={{
                    width: "100%",
                    padding: "10px",
                    objectFit: "contain",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "solid 1px #010038",
                    backgroundColor: "#fff",
                    color: "black",
                  }}
                  name="phone"
                  validate={validateUserName}
                />
                {errors.phone && touched.phone && (
                  <Text color="red">{errors.phone}</Text>
                )}
              </Box>
              <Box position={"relative"} w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="password"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    Password
                  </FormLabel>
                </Flex>

                <Field
                  style={{
                    padding: "10px",
                    objectFit: "contain",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "solid 1px #010038",
                    backgroundColor: "#fff",
                    color: "black",

                    width: "100%",
                  }}
                  name="password"
                  validate={validatePassword}
                  type={inputType}
                />

                <Icon
                  position={"absolute"}
                  right="10px"
                  top="50px"
                  fontSize="33px"
                  color="main_1"
                  as={inputType == "password" ? BiShow : BiLowVision}
                  onClick={() =>
                    inputType == "password"
                      ? setInputType("text")
                      : setInputType("password")
                  }
                />
                {errors.password && touched.password && (
                  <Text color="red" w="180px" textAlign="justify">
                    {errors.password}
                  </Text>
                )}
              </Box>

              <Link className="underline" to="/forget-password">
                Forget password
              </Link>
              <Button
                type="submit"
                w="250px"
                p="22px"
                alignSelf={"center"}
                isLoading={isLoading}
                bg="main_1"
                color="white"
              >
                Login
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>

      <Box position="relative" py="8">
        <Divider />
        <AbsoluteCenter color="black" px="4">
          OR
        </AbsoluteCenter>
      </Box>

      <Text color="black" textAlign="center" marginBottom={10}>
        you don't have account ?{" "}
        <chakra.span
          color="main_1"
          fontWeight={600}
          cursor="pointer"
          onClick={() => navigate("/register")}
        >
          Signup
        </chakra.span>
      </Text>
    </div>
  );
};

export default LoginForm;
